import { TIME_GRID } from 'src/config/constants.ts'
export default {
  methods: {
    getLessons (date) {
      const middleDate = date.clone().startOf('isoWeek').unix()
      // 7+1 is a timezone fix for the selected time range
      const weekSeconds = (7 + 1) * 24 * 60 * 60
      return this.getLessonByEntity(middleDate - weekSeconds, middleDate + 2 * weekSeconds - 1)
    },
    getTimetableTimeFrame (items, hideLabelsAfter6Lesson = true) {
      if (!items || !this.labels || (!items.length && !this.labels.length)) return this.defaultTimeframe

      const lessonBeginsAt = [...items].sort((a, b) => a.minutes_begins_at - b.minutes_begins_at)
      const lessonMinutesBeginsAt = lessonBeginsAt.length ? lessonBeginsAt[0].minutes_begins_at : 0

      const lessonEndsAt = [...items].sort((a, b) => b.minutes_ends_at - a.minutes_ends_at)
      const lessonMinutesEndsAt = lessonEndsAt.length ? lessonEndsAt[0].minutes_ends_at : 0

      const labelEndsAt = [...this.labels].sort((a, b) => a.minutes_ends_at - b.minutes_ends_at)
      const labelMinutesBeginsAt = this.labels.length ? this.getFirstLabel() : this.defaultTimeframe.week_minutes_begins_at
      const labelMinutesEndsAt = this.labels.length ? labelEndsAt[this.labels.length - 1].minutes_ends_at : 0

      return {
        week_minutes_begins_at: lessonMinutesBeginsAt < labelMinutesBeginsAt ? lessonMinutesBeginsAt || labelMinutesBeginsAt : labelMinutesBeginsAt,
        week_minutes_ends_at: lessonMinutesEndsAt > labelMinutesEndsAt ? lessonMinutesEndsAt : labelMinutesEndsAt || lessonMinutesEndsAt,
        lesson_minutes_begins_at: hideLabelsAfter6Lesson ? lessonMinutesBeginsAt : labelMinutesBeginsAt,
        lesson_minutes_ends_at: hideLabelsAfter6Lesson ? lessonMinutesEndsAt : labelMinutesEndsAt
      }
    },
    getFirstLabel () {
      // We use this function to exclude first break from calculations
      // It was massive problem since first break should be hidden, but in timetable height calculations it was still included
      return this.labels[0].type === 'BREAK' ? this.labels[1].minutes_begins_at : this.labels[0].minutes_begins_at
    },
    async viewAllLessons (threads, isPlanner = false) {
      const lesson = threads[0][0]
      let time_begins_at = lesson.begins_at || lesson.time_begins_at
      let time_ends_at = lesson.ends_at || lesson.time_ends_at
      threads.map(s => s.forEach(less => {
        const b_at = less.begins_at || less.time_begins_at
        const e_at = less.ends_at || less.time_ends_at
        if (time_begins_at > b_at) time_begins_at = b_at
        if (time_ends_at < e_at) time_ends_at = e_at
      }))

      const week_day = lesson.weekday
      const week = lesson.week

      await this.$router.push({
        name: isPlanner ? 'management-timetable' : 'timetable',
        query: {
          ...this.$route.query,
          lessonId: undefined,
          week: week,
          time_begins_at: time_begins_at,
          time_ends_at: time_ends_at,
          weekday: week_day,
          lessonInternalId: lesson.id
        }
      })
    },

    isLongBreak (label) {
      return label.minutes_ends_at - label.minutes_begins_at > TIME_GRID.TIMETABLE.SHORT_BREAK_MAX_DURATION_MINUTES
    },

    isInsideLessonFrame ({ minutes_begins_at, hour }, timeFrame) {
      if (minutes_begins_at >= timeFrame.lesson_minutes_begins_at &&
        minutes_begins_at < timeFrame.lesson_minutes_ends_at) return true

      if (hour > 0 && hour < 7) return true

      return false
    }
  }
}
